import { msalConfig } from "../authConfig";
import utils from "../Utils";
import config from "../Config/Config";
import axios from "axios";
import strings from "../Utils/strings";
import authService from "./authService";
import utilFunctions from "../Utils/utilFunctions";
import { PublicClientApplication } from "@azure/msal-browser";
const msalInstance = new PublicClientApplication(msalConfig);

const jwtToken = authService.getToken();
// const jwtToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY2NDVkMjk1YTgzOTM1ODM4NWY3MmUwYiIsImlhdCI6MTcxNTk0MzQ4NywiZXhwIjoxNzIxMTI3NDg3fQ.Bfr7ahy6EJTjJFXv207g63M4bs5ksU9IrmAL57Qypbc';

// const axiosInstance = axios.create({
//     baseURL: config.baseURL,
//     headers: {
//         apiKey: process.env.REACT_APP_API_KEY,
//         authToken: token,
//     }
// });
const axiosInstance = axios.create({
  baseURL: config.baseURL,
  timeout: 100000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers[strings.clinicLogin.label_auth_token] = "Bearer " + authService.getToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.request.use(
  (config) => {
    const language = localStorage.getItem("i18nextLng");
    if (language) {
      let langCode;
      switch (language) {
        case "en-US":
          langCode = "en";
          break;
        case "vietnam":
          langCode = "vi";
          break;
        case "french":
          langCode = "fr";
          break;
        case "en":
          langCode = "en";
          break;
        default:
          langCode = "en";
      }
      config.headers["Accept-Language"] = langCode;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const signOutClickHandler = async () => {
  try {
    await msalInstance.initialize();
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      const homeAccountId = accounts[0].homeAccountId;
      const logoutRequest = {
        account: msalInstance.getAccountByHomeId(homeAccountId),
        mainWindowRedirectUri: config.azureRedirect,
      };
      await msalInstance.logoutPopup(logoutRequest);
    }
  } catch (error) {
    console.error("Logout failed: ", error);
  }
};

function getRefreshTokenFromLocalStorage() {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.includes("refreshtoken")) {
      try {
        const tokenData = JSON.parse(localStorage.getItem(key));
        if (tokenData && tokenData.secret && tokenData.secret.length > 0) {
          return tokenData.secret;
        }
      } catch (error) {
        console.error("Error parsing token data from localStorage:", error);
      }
    }
  }
  return null;
}

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && error.response.data.message === "jwt is expired") {
      try {
        const refreshToken = getRefreshTokenFromLocalStorage();

        if (refreshToken) {
          const url = "https://login.microsoftonline.com/c717746a-f099-449f-afb1-7545611404b2/oauth2/v2.0/token";
          const formData = new URLSearchParams();
          formData.append("grant_type", "refresh_token");
          formData.append("refresh_token", refreshToken);
          formData.append("scope", "api://5aba4238-1e5f-4a18-9f29-20cf7d720667/fv.service.read&write");

          const tokenResponse = await axios.post(url, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });

          const newAccessToken = tokenResponse.data.access_token;
          localStorage.setItem(strings.clinicLogin.label_session, newAccessToken);

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          window.location.reload();
          return axiosInstance(originalRequest);
        } else {
          signOutClickHandler();
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response && response.data && response.data.error_code && response.data.error_code == "10006") {
      utilFunctions.navigateToLogin();
    } else if (response.status == 403) {
      window.open("/#/" + strings.navigation.forbidden, "_self");
    } else if (response.status == 503 && navigator.onLine) {
      // window.open("/#/" + strings.navigation.serverDown, "_self")
    } else {
      return response.data;
    }
  },
  (error) => {
    if (error.response) {
      if (error.response.status == 403) {
        window.open("/#/" + strings.navigation.forbidden, "_self");
      } else if (error.response.status == 503 && navigator.onLine) {
        // window.open("/#/" + strings.navigation.serverDown, "_self")
      }
    } else if (navigator.onLine) {
      // window.open("/#/" + strings.navigation.serverDown, "_self")
    }
    return Promise.reject(error);
  },
);

async function hospitalLogin(body) {
  try {
    return await axiosInstance.post(utils.apiName.hospitalLogin, body);
  } catch (e) {
    return e.response;
  }
}
async function verifyHospitalLogin(body) {
  try {
    return await axiosInstance.post(utils.apiName.verifyHospitalLogin, body);
  } catch (e) {
    return e.response;
  }
}
async function clinicProfileSetup(body) {
  try {
    return await axiosInstance.post(utils.apiName.doctor, body);
  } catch (e) {
    return e.response;
  }
}

async function logout(body) {
  try {
    return await axiosInstance.post(utils.apiName.logout, body);
  } catch (e) {
    return e.response;
  }
}

async function doctorLogin(body) {
  try {
    return await axiosInstance.post(utils.apiName.doctorLogin, body);
  } catch (e) {
    return e.response;
  }
}
async function getInsuranceList() {
  try {
    return await axiosInstance.get(utils.apiName.insuranceList);
  } catch (e) {
    return e.response;
  }
}

async function updateClinicTiming(body) {
  try {
    let token = authService.getToken();
    return await axiosInstance.post(utils.apiName.updateClinicTiming, body, {
      authToken: token,
    });
  } catch (e) {
    return e.response;
  }
}

async function updateNewClinicTiming(body) {
  try {
    let token = authService.getToken();
    return await axiosInstance.patch(utils.apiName.updateNewClinicTiming, body, {
      authToken: token,
    });
  } catch (e) {
    return e.response;
  }
}

async function updateClinicConfiguration(body) {
  try {
    return await axiosInstance.post(utils.apiName.updateClinicConfiguration, body);
  } catch (e) {
    return e.response;
  }
}

async function getClinicTiming(body) {
  try {
    let token = authService.getToken();
    return await axiosInstance.post(utils.apiName.getClinicTiming, body, {
      authToken: token,
    });
  } catch (e) {
    return e.response;
  }
}

async function getDoctorTiming(body) {
  try {
    let token = authService.getToken();
    return await axiosInstance.post(utils.apiName.getDoctorTiming, body, {
      authToken: token,
    });
  } catch (e) {
    return e.response;
  }
}

async function getClinicConfiguration(body) {
  try {
    return await axiosInstance.post(utils.apiName.clinicConfiguration, body);
  } catch (e) {
    return e.response;
  }
}

async function getClinicProfile(body) {
  try {
    return await axiosInstance.post(utils.apiName.getClinicProfile, body);
  } catch (e) {
    return e.response;
  }
}
async function azurePrecheck(body) {
  try {
    return await axiosInstance.post(utils.apiName.azurePrecheck, body);
  } catch (e) {
    return e.response;
  }
}

async function getClinicProfileView() {
  try {
    return await axiosInstance.get(utils.apiName.getClinicProfile);
  } catch (e) {
    return e.response;
  }
}

async function getClinicAllHolidayList(body) {
  try {
    return await axiosInstance.post(utils.apiName.getClinicHolidayList, body);
  } catch (e) {
    return e.response;
  }
}

async function getDoctorSpecialtyDepart() {
  try {
    const response = await axiosInstance.get(utils.apiName.getDoctorSpecialtyDepart, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docGetClinicProfile() {
  try {
    const response = await axiosInstance.get(utils.apiName.docGetClinicProfile, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

async function getLanguages() {
  try {
    const response = await axiosInstance.get(utils.apiName.getLanguages, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docGetLanguages() {
  try {
    const response = await axiosInstance.get(utils.apiName.docGetLanguages, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docGetAllAppointment(docBody) {
  const { date, statuses } = docBody;
  const queryString = new URLSearchParams({
    date,
    limit: "99999",
  });
  statuses.forEach((status) => queryString.append("status", status));
  queryString.append("sort", "-startTime");
  try {
    const response = await axiosInstance.get(utils.apiName.docGetAllAppointment + "?" + queryString.toString());
    return response;
  } catch (e) {
    return e.response;
  }
}

async function addDoctor(body) {
  try {
    const response = await axiosInstance.post(utils.apiName.addDoctor, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function editDoctor(docId, body) {
  try {
    const response = await axiosInstance.put(utils.apiName.addDoctor + "/" + docId, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docEditDoctor(body) {
  try {
    const response = await axiosInstance.put(utils.apiName.docEditDoctor, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function uploadHospitalMedia(files) {
  const formData = new FormData();
  formData.append("files", files);
  try {
    const response = await axiosInstance.post(utils.apiName.uploadHospitalMedia, formData, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function uploadDocs(id, formData) {
  try {
    const response = await axiosInstance.post(utils.apiName.medicalFiles + `${id}`, formData, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docUploadInvoices(id, formData) {
  try {
    const response = await axiosInstance.post(utils.apiName.docUploadInvoices + `${id}`, formData);
    return response;
  } catch (e) {
    return e.response;
  }
}
async function uploadDoctorMedia(files) {
  const formData = new FormData();
  formData.append("files", files);
  try {
    const response = await axiosInstance.post(utils.apiName.uploadDoctorMedia, formData, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function getZoomToken(appId) {
  try {
    const response = await axiosInstance.get(utils.apiName.getZoomToken + appId);
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docGetZoomToken(appId) {
  try {
    const response = await axiosInstance.get(utils.apiName.docGetZoomToken + appId);
    return response;
  } catch (e) {
    return e.response;
  }
}

async function createDoctorLeave(body) {
  try {
    const response = await axiosInstance.post(utils.apiName.createDoctorLeave, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docLogCreateLeaave(body) {
  try {
    const response = await axiosInstance.post(utils.apiName.docCreateDocLeave, body);
    return response;
  } catch (e) {
    return e.response;
  }
}
async function getDocLeaveList(doctorId) {
  try {
    const response = await axiosInstance.get(
      utils.apiName.createDoctorLeave + "/" + doctorId,
      {},
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      },
    );
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docGetLeavelist(doctorId) {
  try {
    const response = await axiosInstance.get(utils.apiName.docGetLeaveList);
    return response;
  } catch (e) {
    return e.response;
  }
}
async function delDocLeave(doctorId, selectedLeaveId) {
  try {
    const response = await axiosInstance.put(utils.apiName.deleteDoctorLeave + doctorId + "/" + selectedLeaveId);
    return response;
  } catch (e) {
    return e.response;
  }
}
async function docDelDocLeave(doctorId, selectedLeaveId) {
  try {
    const response = await axiosInstance.put(utils.apiName.docGetLeaveList + "/" + selectedLeaveId);
    return response;
  } catch (e) {
    return e.response;
  }
}
async function getDoctorList() {
  try {
    const response = await axiosInstance.get(utils.apiName.getDoctorList, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function updateHospitalProfile(body) {
  try {
    const response = await axiosInstance.put(utils.apiName.updateHospitalProfile, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

async function hospitalProfile() {
  try {
    const response = await axiosInstance.get(utils.apiName.hospitalProfile, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

async function createDoctorUsername(body) {
  try {
    return await axiosInstance.post(utils.apiName.createDoctorUsername, body);
  } catch (e) {
    return e.response;
  }
}

async function uploadDoctorProfilePic(body) {
  try {
    return await axiosInstance.post(utils.apiName.uploadDoctorProfilePic, body);
  } catch (e) {
    return e.response;
  }
}

async function uploadClinicProfilePic(body) {
  try {
    return await axiosInstance.post(utils.apiName.uploadClinicProfilepic, body);
  } catch (e) {
    return e.response;
  }
}

async function uploadClinicLogo(body, id) {
  try {
    return await axiosInstance.post(utils.apiName.uploadClinicLogo + id, body);
  } catch (e) {
    return e.response;
  }
}

async function getDoctorAllHolidaysList(body) {
  try {
    return await axiosInstance.post(utils.apiName.getDoctorAllHolidayList, body);
  } catch (e) {
    return e.response;
  }
}
async function getDoctorAllHolidaysListDoc() {
  try {
    return await axiosInstance.post(utils.apiName.docLogHolidayList);
  } catch (e) {
    return e.response;
  }
}
async function getDoctorLeaveList(selectedDate) {
  try {
    return await axiosInstance.get(utils.apiName.getDoctorLeaveList + "?date=" + selectedDate);
  } catch (e) {
    return e.response;
  }
}
async function hospitalFcmToken(body) {
  try {
    return await axiosInstance.post(utils.apiName.hospitalFcmToken, body);
  } catch (e) {
    return e.response;
  }
}
async function doctorFcmToken(body) {
  try {
    return await axiosInstance.post(utils.apiName.doctorFcmToken, body);
  } catch (e) {
    return e.response;
  }
}
async function doctorDelFcmToken(body) {
  try {
    return await axiosInstance.post(utils.apiName.doctorDelFcmToken, body);
  } catch (e) {
    return e.response;
  }
}
async function hospitalDelFcmToken(body) {
  try {
    return await axiosInstance.post(utils.apiName.hospitalDelFcmToken, body);
  } catch (e) {
    return e.response;
  }
}

async function removeClinicHoliday(body) {
  try {
    return await axiosInstance.post(utils.apiName.removeClinicHoliday, body);
  } catch (e) {
    return e.response;
  }
}

async function getDoctorProfile(body) {
  try {
    return await axiosInstance.post(utils.apiName.getClinicProfileEditDoctor, body);
  } catch (e) {
    return e.response;
  }
}

async function editDoctorProfile(body) {
  try {
    return await axiosInstance.post(utils.apiName.editDoctorProfile, body);
  } catch (e) {
    return e.response;
  }
}

async function createClinicHoliday(body) {
  try {
    return await axiosInstance.post(utils.apiName.createClinicHoliday, body);
  } catch (e) {
    return e.response;
  }
}

async function updateDoctorProfile(body) {
  try {
    return await axiosInstance.post(utils.apiName.updateDoctorProfile, body);
  } catch (e) {
    return e.response;
  }
}

async function createDoctorHolidayBefore(body) {
  try {
    return await axiosInstance.post(utils.apiName.createDoctorHolidayBefore, body);
  } catch (e) {
    return e.response;
  }
}

async function createDoctorHoliday(body) {
  try {
    return await axiosInstance.post(utils.apiName.createDoctorHoliday, body);
  } catch (e) {
    return e.response;
  }
}

async function setAsDoctorWorkingDay(doctorId, selectedLeaveId) {
  try {
    const response = await axiosInstance.put(utils.apiName.deleteDoctorLeave + doctorId + "/" + selectedLeaveId, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

async function getDoctorHolidaysListLimit(body) {
  try {
    return await axiosInstance.post(utils.apiName.getDoctorHolidaysListLimit);
  } catch (e) {
    return e.response;
  }
}

async function createClinicHolidayBefore(body) {
  try {
    return await axiosInstance.post(utils.apiName.createClinicHolidayBefore, body);
  } catch (e) {
    return e.response;
  }
}

async function updateDoctorProfilePic(body, id) {
  try {
    return await axiosInstance.post(utils.apiName.updateDoctorProfilePic + id, body);
  } catch (e) {
    return e.response;
  }
}

async function getDoctorProfileView(doctorId) {
  try {
    const response = await axiosInstance.get(utils.apiName.getDoctorList + "/" + doctorId, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function getDoctorDetials() {
  try {
    const response = await axiosInstance.get(utils.apiName.doctorProfile);
    return response;
  } catch (e) {
    return e.response;
  }
}

async function createHospitalLeave(body) {
  try {
    const response = await axiosInstance.post(utils.apiName.createHospitalLeave, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

async function getAllLeaves() {
  try {
    const response = await axiosInstance.get(utils.apiName.getAllLeaves, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    console.error("Error fetching leaves:", e.response || e.message);
    return e.response;
  }
}

async function deleteHospitalLeave(leaveId) {
  try {
    const response = await axiosInstance.put(
      utils.apiName.deleteHospitalLeave + `/${leaveId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      },
    );
    return response;
  } catch (e) {
    return e.response;
  }
}

// export const hospitalAppointment = async (formData, jwtToken) => {
//   try {
//     // Extract values from formData to construct the query string
//     const { date, doctor, statuses } = formData;

//     // Check if required fields are present
//     if (
//       !date ||
//       !doctor ||
//       !statuses ||
//       !Array.isArray(statuses) ||
//       statuses.length === 0
//     ) {
//       throw new Error(
//         "Missing or invalid required fields: date, doctor, or statuses."
//       );
//     }

//     // Construct the query string based on the parameters
//     const queryString = new URLSearchParams({
//       date, // Date of appointment
//       doctor, // Doctor's ID
//     });

//     // Add multiple status parameters
//     statuses.forEach((status) => queryString.append("status", status));

//     // Ensure utils.apiName.hospitalAppointment is a valid string
//     const apiUrl = utils.apiName.hospitalAppointment;
//     if (!apiUrl) {
//       throw new Error("Invalid API URL for hospitalAppointment.");
//     }

//     // Full URL with query parameters
//     const requestUrl = `${apiUrl}?${queryString.toString()}`;

//     // console.log("Sending GET request to:", requestUrl);
//     // console.log("JWT Token:", jwtToken);

//     // Make the GET request
//     const response = await axiosInstance.get(requestUrl, {
//       headers: {
//         Authorization: `Bearer ${jwtToken}`,
//       },
//     });

//     // Console the fetched data here
//     // console.log("Fetched data from hospitalAppointment:", response.data);

//     return response.data; // Assuming response contains data field
//   } catch (error) {
//     // Log full error details
//     console.error("Error in hospitalAppointment GET request:", error);

//     // Safely log the response if available
//     if (error.response) {
//       console.error("Response status:", error.response.status);
//       console.error("Response data:", error.response.data);
//     } else {
//       console.error("No response from server.");
//     }

//     // Throw a more informative error
//     throw new Error(`Failed to fetch hospital appointments: ${error.message}`);
//   }
// };

export const hospitalAppointment = async (formData, jwtToken) => {
  try {
    // Destructure values from formData
    const { date, doctor, statuses } = formData;
    // Validate required fields
    if (!date || !doctor || !Array.isArray(statuses) || statuses.length === 0) {
      throw new Error("Missing or invalid required fields: date, doctor, or statuses.");
    }
    // Construct the query string
    const queryString = new URLSearchParams({
      date, // Date of appointment
      doctor, // Doctor's ID
      limit: "99999",
      //   sort: "-updatedAt",
    });
    // Append each status to the query string
    statuses.forEach((status) => queryString.append("status", status));
    queryString.append("sort", "-startTime");
    // Validate the API URL
    const apiUrl = utils.apiName.hospitalAppointment;
    if (!apiUrl) {
      throw new Error("Invalid API URL for hospitalAppointment.");
    }
    // Construct the full request URL
    const requestUrl = `${apiUrl}?${queryString.toString()}`;
    // Make the GET request
    const response = await axiosInstance.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    // Return the response data
    return response.data; // Ensure response contains the expected data structure
  } catch (error) {
    // Log additional details if response is available
    if (error.response) {
      //   console.error("Response status:", error.response.status);
      //   console.error("Response data:", error.response.data);
    } else {
      //   console.error("No response from server. Error message:", error.message);
    }

    // Throw a descriptive error for higher-level handling
    throw new Error(`Failed to fetch hospital appointments: ${error.message}`);
  }
};

export const hospitalAppointmentDashboard = async (formData, jwtToken) => {
  try {
    // Destructure values from formData
    const { date, statuses } = formData;
    // Validate required fields
    if (!date || !Array.isArray(statuses) || statuses.length === 0) {
      throw new Error("Missing or invalid required fields: date, doctor, or statuses.");
    }
    // Construct the query string
    const queryString = new URLSearchParams({
      date, // Date of appointment
      //   sort: "-updatedAt",
    });
    // Append each status to the query string
    statuses.forEach((status) => queryString.append("status", status));
    queryString.append("sort", "-startTime");
    // Validate the API URL
    const apiUrl = utils.apiName.hospitalAppointment;
    if (!apiUrl) {
      throw new Error("Invalid API URL for hospitalAppointment.");
    }
    // Construct the full request URL
    const requestUrl = `${apiUrl}?${queryString.toString()}`;
    // Make the GET request
    const response = await axiosInstance.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    // Return the response data
    return response.data; // Ensure response contains the expected data structure
  } catch (error) {
    // Log additional details if response is available
    if (error.response) {
      //   console.error("Response status:", error.response.status);
      //   console.error("Response data:", error.response.data);
    } else {
      //   console.error("No response from server. Error message:", error.message);
    }

    // Throw a descriptive error for higher-level handling
    throw new Error(`Failed to fetch hospital appointments: ${error.message}`);
  }
};

async function getManageDoctorList() {
  try {
    return await axiosInstance.get(utils.apiName.getManageDoctorList);
  } catch (e) {
    return e.response;
  }
}

async function deleteDoctorBefore(body) {
  try {
    return await axiosInstance.post(utils.apiName.deleteDoctorBefore, body);
  } catch (e) {
    return e.response;
  }
}

async function deleteDoctorProfile(body) {
  try {
    return await axiosInstance.post(utils.apiName.deleteDoctorProfile, body);
  } catch (e) {
    return e.response;
  }
}

async function changePassword(body) {
  try {
    return await axiosInstance.post(utils.apiName.changePassword, body);
  } catch (e) {
    return e.response;
  }
}

async function forgotPassword(body) {
  try {
    return await axiosInstance.post(utils.apiName.forgotPassword, body);
  } catch (e) {
    return e.response;
  }
}

async function editSpeciality(body) {
  try {
    return await axiosInstance.put(utils.apiName.editSpeciality, body);
  } catch (e) {
    return e.response;
  }
}

async function updateDoctorTiming(body) {
  try {
    return await axiosInstance.post(utils.apiName.updateDoctorTiming, body);
  } catch (e) {
    return e.response;
  }
}

async function updateNewDoctorTiming(body) {
  try {
    return await axiosInstance.patch(utils.apiName.updateNewDoctorTiming, body);
  } catch (e) {
    return e.response;
  }
}

async function deleteSpeciality(departmentId) {
  try {
    return await axiosInstance.delete(utils.apiName.deleteSpeciality + `?id=${departmentId}`);
  } catch (e) {
    return e.response;
  }
}

async function addSpeciality(body) {
  try {
    return await axiosInstance.post(utils.apiName.addSpeciality, body);
  } catch (e) {
    return e.response;
  }
}

async function getMappedPatientList(body) {
  try {
    return await axiosInstance.post(utils.apiName.getMappedPatientList, body);
  } catch (e) {
    return e.response;
  }
}

async function updateVitalNotification(body) {
  try {
    return await axiosInstance.post(utils.apiName.updateVitalNotification, body);
  } catch (e) {
    return e.response;
  }
}

async function getAppointmentDetailsForClinicTiming(docId) {
  try {
    return docId !== undefined
      ? await axiosInstance.get(utils.apiName.getAppointmentDetailsForClinicTiming + `?doctorId=${docId}`)
      : await axiosInstance.get(utils.apiName.getAppointmentDetailsForClinicTiming);
  } catch (e) {
    return e.response;
  }
}

// // async function getAppointmentCalender(month,year){
// //      try {
//             return await axiosInstance.get(utils.apiName.getAppointmentCalendar, {
//                headers: {
//                  Authorization: `Bearer ${jwtToken}`,
//                },
//                params: { month: `${year}-${month}` },
//              });

//      } catch (e) {
//        return e.response;
//      }

// }
async function getAppointmentCalender(month, year, selectedArray) {
  try {
    const params = { month: `${year}-${month}` };

    selectedArray.forEach((status) => {
      params["status[]"] = params["status[]"] || [];
      params["status[]"].push(status);
    });

    return await axiosInstance.get(utils.apiName.getAppointmentCalendar, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      params,
    });
  } catch (error) {
    console.error("Error fetching appointment calendar:", error);
  }
}
async function docGetAppointmentCalender(month, year, selectedArray) {
  try {
    const params = { month: `${year}-${month}` };

    selectedArray.forEach((status) => {
      params["status[]"] = params["status[]"] || [];
      params["status[]"].push(status);
    });

    return await axiosInstance.get(utils.apiName.docGetAppointmentCalender, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      params,
    });
  } catch (error) {
    console.error("Error fetching appointment calendar:", error);
  }
}
async function getDashboardAppointments(selectedArray, selectedDate, page) {
  try {
    const params = { date: selectedDate, page: page };

    selectedArray.forEach((status) => {
      params["status"] = params["status"] || [];
      params["status"].push(status);
    });

    return await axiosInstance.get(utils.apiName.getDashboardAppointments, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      params,
    });
  } catch (error) {
    console.error("Error fetching appointment calendar:", error);
  }
}
async function docGetDashboardAppointments(selectedArray, selectedDate, page) {
  try {
    const params = { date: selectedDate, page: page };

    selectedArray.forEach((status) => {
      params["status"] = params["status"] || [];
      params["status"].push(status);
    });

    return await axiosInstance.get(utils.apiName.docGetAllAppointment, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      params,
    });
  } catch (error) {
    console.error("Error fetching appointment calendar:", error);
  }
}

async function getAppointments(body) {
  try {
    const { date, statuses } = body;

    // Input validation
    if (!date || !Array.isArray(statuses)) {
      throw new Error("Missing or invalid required fields: date, or statuses.");
    }

    // Construct the query string
    const queryString = new URLSearchParams({
      date, // Date of appointment
      limit: "99999",
    });

    // Append each status to the query string
    statuses.forEach((status) => queryString.append("status", status));

    const apiUrl = utils.apiName.hospitalAppointment;
    if (!apiUrl) {
      throw new Error("Invalid API URL for hospitalAppointment.");
    }

    // Construct the full request URL
    const requestUrl = `${apiUrl}?${queryString.toString()}`;

    // Make the GET request
    const response = await axiosInstance.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });

    return response.data; // Ensure response contains the expected data structure
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data); // Log the response error
    } else {
      console.error("Error Message:", error.message); // Log the error message
    }
    throw new Error(`Failed to fetch hospital appointments: ${error.message}`);
  }
}
// async function getAppointments(formData) {
//   try {
//     const { date, statuses } = formData;

//     if (!date || !Array.isArray(statuses)) {
//       throw new Error("Missing or invalid required fields: date, or statuses.");
//     }

//     // Construct the query string
//     const queryString = new URLSearchParams({
//       date, // Date of appointment
//     });

//     // Append each status to the query string
//     statuses.forEach((status) => queryString.append("status", status));

//     const apiUrl = utils.apiName.hospitalAppointment;
//     if (!apiUrl) {
//       throw new Error("Invalid API URL for hospitalAppointment.");
//     }

//     // Construct the full request URL
//     const requestUrl = `${apiUrl}?${queryString.toString()}`;

//     // Make the GET request
//     const response = await axiosInstance.get(requestUrl, {
//       headers: {
//         Authorization: `Bearer ${jwtToken}`,
//       },
//     });

//     return response.data; // Ensure response contains the expected data structure
//   } catch (error) {
//     if (error.response) {
//     } else {
//     }
//     throw new Error(`Failed to fetch hospital appointments: ${error.message}`);
//   }
// }
async function getDoctorLeave(id) {
  try {
    return await axiosInstance.get(`${utils.apiName.getDoctorLeave}/${id}`, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
  } catch (e) {
    return e.response;
  }
}
async function acceptAppointment(id, body) {
  try {
    return await axiosInstance.post(`${utils.apiName.acceptAppointment}/${id}`, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
  } catch (e) {
    return e.response;
  }
}
async function docAcceptAppointment(id, body) {
  try {
    return await axiosInstance.post(`${utils.apiName.docAcceptAppointment}/${id}`, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
  } catch (e) {
    return e.response;
  }
}

async function getClinicReport(startDate, endDate, id) {
  try {
    const response = await axiosInstance.get(`${utils.apiName.clinicReport}?startDate=${startDate}&endDate=${endDate}&doctor=${id}`, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}
async function getDoctorOverview(startDate, endDate, id) {
  try {
    // Construct the base URL
    let url = `${utils.apiName.doctorReport}?startDate=${startDate}&endDate=${endDate}`;

    // Add the doctor parameter only if `id` has a value
    if (id) {
      url += `&doctor=${id}`;
    }

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });

    return response;
  } catch (e) {
    return e.response;
  }
}
async function getCompletedAppointments(limit, currentPage) {
  try {
    return await axiosInstance.get(utils.apiName.getCompletedAppointments, {
      params: {
        limit: limit,
        page: currentPage,
      },
    });
  } catch (e) {
    return e.response;
  }
}
async function getDoctorRevenue(limit, currentPage) {
  try {
    return await axiosInstance.get(utils.apiName.getDoctorRevenue, {
      params: {
        limit: limit,
        page: currentPage,
      },
    });
  } catch (e) {
    return e.response;
  }
}
async function getDoctorsAppointments(limit, currentPage) {
  try {
    return await axiosInstance.get(utils.apiName.completedAppointmentDoctors, {
      params: {
        limit: limit,
        page: currentPage,
      },
    });
  } catch (e) {
    return e.response;
  }
}

async function getNotificationsList(limit, currentPage) {
  try {
    return await axiosInstance.get(utils.apiName.getNotifications, {
      params: {
        limit: limit,
        page: currentPage,
      },
    });
  } catch (e) {
    return e.response;
  }
}

async function getDoctorNotificationsList(limit, currentPage) {
  try {
    return await axiosInstance.get(utils.apiName.getDoctorNotifications, {
      params: {
        limit: limit,
        page: currentPage,
      },
    });
  } catch (e) {
    return e.response;
  }
}

async function getDoctorReadNotification(id) {
  try {
    return await axiosInstance.patch(`${utils.apiName.readDocNotification}/${id}`);
  } catch (e) {
    return e.response;
  }
}

async function getHospitalReadNotification(id) {
  try {
    return await axiosInstance.patch(`${utils.apiName.readHosNotification}/${id}`);
  } catch (e) {
    return e.response;
  }
}

async function hospitalLangTranslation(language) {
  try {
    return await axiosInstance.put(`${utils.apiName.langTranslation}`,{
        selectedLanguage:language
    });
  } catch (e) {
    return e.response;
  }
}

async function doctorLangTranslation(language) {
  try {
    return await axiosInstance.put(`${utils.apiName.docLangTranslation}`,{
        selectedLanguage:language
    });
  } catch (e) {
    return e.response;
  }
}

async function hospitalNotificationStatus(id) {
  try {
    return await axiosInstance.get(`${utils.apiName.hosNotificationStatus}/${id}`)
  } catch (e) {
    return e.response;
  }
}

async function DoctorNotificationStatus(id) {
  try {
    return await axiosInstance.get(`${utils.apiName.docNotificationStatus}/${id}`)
  } catch (e) {
    return e.response;
  }
}


// async function getAppointmentCalender(month,year){
//      try {
//             return await axiosInstance.get(utils.apiName.getAppointmentCalendar, {
//                headers: {
//                  Authorization: `Bearer ${jwtToken}`,
//                },
//                params: { month: `${year}-${month}` },
//              });

//      } catch (e) {
//        return e.response;
//      }

// }
// async function getAppointmentByStatus(formData ){
//       try {
//         // Destructure values from formData
//         const { date, statuses } = formData;
//         // console.log(statuses,"dd",formData)

//         // Validate required fields
//         if (
//           !date ||
//           !Array.isArray(statuses)
//         ) {
//           throw new Error(
//             "Missing or invalid required fields: date, or statuses."
//           );
//         }

//         // Construct the query string
//         const queryString = new URLSearchParams({
//           date, // Date of appointment
//         //   doctor, // Doctor's ID
//         });

//         // Append each status to the query string
//         statuses.forEach((status) => queryString.append("status", status));

//         // Validate the API URL
//         const apiUrl = utils.apiName.hospitalAppointment;
//         if (!apiUrl) {
//           throw new Error("Invalid API URL for hospitalAppointment.");
//         }

//         // Construct the full request URL
//         const requestUrl = `${apiUrl}?${queryString.toString()}`;

//         // Make the GET request
//         const response = await axiosInstance.get(requestUrl, {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         });

//         // Return the response data
//         return response.data; // Ensure response contains the expected data structure
//       } catch (error) {
//         // Log additional details if response is available
//         if (error.response) {
//           //   console.error("Response status:", error.response.status);
//           //   console.error("Response data:", error.response.data);
//         } else {
//           //   console.error("No response from server. Error message:", error.message);
//         }

//         // Throw a descriptive error for higher-level handling
//         throw new Error(
//           `Failed to fetch hospital appointments: ${error.message}`
//         );
//       }

// }
// async function getDoctorLeave(id){
//     try {
//         return await axiosInstance.get(
//             `${utils.apiName.getDoctorLeave}/${id}`,
//             {
//                 headers: {
//                     Authorization: `Bearer ${jwtToken}`
//                 }
//             }
//         );
//     } catch (e) {
//         return e.response;
//     }
// }
// async function acceptAppointment(id, body) {
//     try {
//         return await axiosInstance.post(
//             `${utils.apiName.acceptAppointment}/${id}`,
//             body,
//             {
//                 headers: {
//                     Authorization: `Bearer ${jwtToken}`
//                 }
//             }
//         );
//     } catch (e) {
//         return e.response;
//     }
// }

// async function getAllLeaves() {
//     try {
//         const response = await axiosInstance.get(utils.apiName.getAllLeaves, {
//             headers: {
//                 Authorization: `Bearer ${jwtToken}`
//             }
//         });
//         return response.data;
//     } catch (e) {

//         console.error('Error fetching leaves:', e.response || e.message);
//         return e.response;
//     }
// }

async function getAvailableDepartments() {
  try {
    const response = await axiosInstance.get(utils.apiName.getAvailableDepartments, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

async function updateHospitalDepartments(body) {
  try {
    const response = await axiosInstance.put(utils.apiName.updateHospitalProfile, body, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
}

const clinicService = {
  hospitalLogin,
  doctorLogin,
  verifyHospitalLogin,
  clinicProfileSetup,
  updateHospitalProfile,
  hospitalProfile,
  logout,
  getClinicConfiguration,
  getInsuranceList,
  updateClinicTiming,
  updateNewClinicTiming,
  getClinicTiming,
  getDoctorTiming,
  docGetLanguages,
  docGetAllAppointment,
  getDoctorSpecialtyDepart,
  getLanguages,
  addDoctor,
  createDoctorUsername,
  uploadDoctorProfilePic,
  uploadClinicProfilePic,
  getDashboardAppointments,
  uploadClinicLogo,
  getClinicProfile,
  getDoctorAllHolidaysList,
  getDoctorProfile,
  getClinicAllHolidayList,
  getDoctorAllHolidaysListDoc,
  editDoctorProfile,
  docGetLeavelist,
  docDelDocLeave,
  docGetClinicProfile,
  getDoctorDetials,
  docLogCreateLeaave,
  docEditDoctor,
  docGetDashboardAppointments,
  docGetAppointmentCalender,
  uploadDoctorMedia,
  uploadHospitalMedia,
  updateDoctorProfile,
  createDoctorHolidayBefore,
  createDoctorHoliday,
  setAsDoctorWorkingDay,
  getDoctorLeaveList,
  editDoctor,
  getZoomToken,
  createDoctorLeave,
  getDocLeaveList,
  delDocLeave,
  getDoctorHolidaysListLimit,
  updateDoctorProfilePic,
  azurePrecheck,
  updateClinicConfiguration,
  createClinicHoliday,
  docAcceptAppointment,
  createClinicHolidayBefore,
  docGetZoomToken,
  removeClinicHoliday,
  getClinicProfileView,
  getDoctorProfileView,
  getManageDoctorList,
  getDoctorList,
  deleteDoctorProfile,
  deleteDoctorBefore,
  changePassword,
  forgotPassword,
  editSpeciality,
  docUploadInvoices,
  hospitalFcmToken,
  doctorFcmToken,
  doctorDelFcmToken,
  hospitalDelFcmToken,
  deleteSpeciality,
  addSpeciality,
  updateDoctorTiming,
  updateNewDoctorTiming,
  getMappedPatientList,
  updateVitalNotification,
  getAppointmentDetailsForClinicTiming,
  hospitalAppointment,
  getAllLeaves,
  getAppointmentCalender,
  //   getAppointmentByStatus,
  getAppointments,
  getDoctorLeave,
  acceptAppointment,
  createHospitalLeave,
  getAllLeaves,
  getAvailableDepartments,
  updateHospitalDepartments,
  deleteHospitalLeave,
  uploadDocs,
  getClinicReport,
  getCompletedAppointments,
  getDoctorRevenue,
  getDoctorOverview,
  getDoctorsAppointments,
  hospitalAppointmentDashboard,
  getNotificationsList,
   getDoctorNotificationsList,
    getDoctorReadNotification,
    getHospitalReadNotification,
     hospitalLangTranslation,
    doctorLangTranslation,
    hospitalNotificationStatus,
    DoctorNotificationStatus
};

export default clinicService;
